// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AVcW","field":"styles_field__2KdPu","fieldCol":"styles_fieldCol__1wsL3","diffCol":"styles_diffCol__3f97K","diff":"styles_diff__2o_rI"};